// extracted by mini-css-extract-plugin
var _1 = "tooltip_background__1vbq8";
var _2 = "#4c4c4c";
var _3 = "tooltip_content__+1wy4";
var _4 = "tooltip_contentwrapper__w3y35";
var _5 = "640px";
var _6 = "790px";
var _7 = "#057676";
var _8 = "#434343";
var _9 = "tooltip_hidden__thcpk";
var _a = "tooltip_infopopover__o1r2e";
var _b = "79px";
var _c = "110px";
var _d = "72px";
var _e = "665px";
var _f = "tooltip_spacer__zztd2";
var _10 = "teal";
var _11 = "2";
var _12 = "#cdd3dc";
var _13 = "tooltip_tooltip__jpjge";
var _14 = "tooltip_visible__fo0vt";
var _15 = "tooltip_wrapper__r-6co";
export { _1 as "background", _2 as "body", _3 as "content", _4 as "contentWrapper", _5 as "controlsMobileWidth", _6 as "controlsStackedWidth", _7 as "darkTeal", _8 as "headline", _9 as "hidden", _a as "infoPopover", _b as "menuHeight", _c as "menuHeightLarge", _d as "menuHeightMobile", _e as "modalMobileWidth", _f as "spacer", _10 as "teal", _11 as "timelineStrokeWidth", _12 as "timelineTrackColor", _13 as "tooltip", _14 as "visible", _15 as "wrapper" }
